import { useQuery } from '@tanstack/react-query';

import { useWorkspace } from '@/app/workspace/use-workspace.js';
import { listStaffConversations } from '@/features/conversation/api/staff-conversations.api.js';
import { staffConversationKeys } from '@/features/conversation/query-keys.js';

export function useStaffConversations() {
  const { activePlace } = useWorkspace();
  const placeId = activePlace?.id ?? '';
  return useQuery({
    queryKey: staffConversationKeys.list(placeId),
    queryFn: () => listStaffConversations({ limit: 50 }),
    enabled: placeId.length > 0,
  });
}
